<template>
  <section class="container">
    <div class="columns is-centered">
      <div class="column is-8">
        <div class="mb-5">
          <router-link to="/planned-trips" class="has-text-weight-bold"
            >Trips</router-link
          >
          > <span class="has-text-weight-light">Past Trips</span>
        </div>
        <div class="boxWithBorder">
          <div class="level mb-4">
            <div class="level-left">
              <h4 class="title is-5">
                <b-icon icon="history" class="mr-2"></b-icon>
                Past Trips
              </h4>
            </div>
            <div class="level-right">
              <div class="trip-count-info has-text-right">
                <div v-if="trips.length > 0" class="is-size-6 has-text-grey-dark">
                  <span v-if="trips.length == 1">
                    {{ this.tripsLoaded.length }} Trip Found
                  </span>
                  <span v-else>
                    {{ this.tripsLoaded.length }} Prior Trips Found
                  </span>
                </div>
                <div class="is-size-7">
                  <router-link :to="{ name: 'planned-trips' }" class="has-text-grey">
                    View upcoming trips
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div>
              <!-- Trip Loading State -->
              <div v-if="pageLoading">
                <b-skeleton :animated="true" height="80px" class="mb-3"></b-skeleton>
                <b-skeleton :animated="true" height="80px" class="mb-3"></b-skeleton>
                <b-skeleton :animated="true" height="80px"></b-skeleton>
              </div>
              <div v-else-if="trips.length > 0">
                <div v-if="detailsLoading" class="notification is-warning">
                  Loading {{ this.tripsLoaded.length }} of
                  {{ this.trips.length }} trips...
                </div>

                <div
                  v-else-if="!detailsLoading && this.tripsNotLoaded.length > 0"
                  class="notification is-danger is-light"
                  @click="fetchTripDetails()"
                  style="cursor:pointer"
                >
                  {{ this.tripsNotLoaded.length }} trips failed to load. Click
                  here to retry.
                </div>

                <div v-if="cancelledTrips.length">
                  <div class="has-text-grey-dark is-size-5 has-text-weight-bold mb-4">
                    Recently cancelled trips:
                  </div>
                  <TripListCompact :trips="cancelledTrips" />
                </div>

                <div v-if="inactiveTrips.length" class="mt-6">
                  <div class="has-text-grey-dark is-size-5 has-text-weight-bold mb-4">
                    {{ inactiveTrips.length }} Recently completed trips
                  </div>
                  <div class="notification is-info is-light">
                    <div class="content">
                      <p>
                        <b-icon icon="information-outline" class="mr-2"></b-icon>
                        For invoices and detailed trip information, please visit:
                      </p>
                      <p>
                        <a href="https://www.gantgateway.com/invoices" target="_blank" class="has-text-weight-semibold">
                          Gant Gateway Invoice Portal
                          <b-icon icon="open-in-new" size="is-small" class="ml-1"></b-icon>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- No Trips State -->
              <div v-else-if="noTripsFound" class="has-text-centered mt-6">
                <b-icon icon="history" size="is-large" type="is-grey-light" class="mb-3"></b-icon>
                <p class="title is-6 mb-2">No past trips found</p>
                <!-- <p class="is-7 has-text-grey">Your completed and cancelled trips will appear here.</p> -->
              </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
//import TripModal from "../components/Trip/TripModal.vue";
import TripListCompact from "../components/Trip/TripListCompact.vue";
export default {
  name: "PastTripsPage",
  components: {
    TripListCompact,
  },
  data: function() {
    return {
      trips: [],
      pageLoading: true,
      tripKey: 1,
      noTripsFound: false,
      loadStatus: [],
    };
  },
  computed: {
    /*
    solution() {
      return this.$store.state.result;
    },
    disable() {
      return (
        Object.keys(this.solution.car).length === 0 &&
        Object.keys(this.solution.hotel).length === 0 &&
        Object.keys(this.solution.flight).length === 0
      );
    },
    tripsList() {
      return this.tripSummary;
    },
    noTripsFound() {
      return this.trips.length === 0;
    },
    groups() {
      let trips = this.trips.data;
      if (trips == []) {
        return [];
      }
      let bigGroups = [[trips[0]]];
      let i = 0;
      for (let x = 1; x < trips.length; x++) {
        if (bigGroups[i].length >= 3) {
          bigGroups.push([]);
          i += 1;
        }
        bigGroups[i].push(trips[x]);
      }
      return bigGroups;
    },
    booked() {
      return this.$store.state.booked;
    },
    */

    inactiveTrips() {
      return this.tripsLoaded.filter((trip) => {
        return trip.tripSummary.status == "inactive" || trip.tripSummary.status == "completed";
      });
    },
    cancelledTrips() {
      return this.tripsLoaded.filter((trip) => {
        return trip.tripSummary.status == "cancelled";
      });
    },
    activeTrips() {
      return this.tripsLoaded.filter((trip) => {
        return trip.tripSummary.status == "active";
      });
    },
    //Contains all trips that have been loaded with their associated trip details
    tripsLoaded() {
      return this.trips.filter((_, index) => {
        return this.loadStatus[index].loaded === true;
      });
    },
    //Array that contains any trips that are still missing trip details
    tripsNotLoaded() {
      return this.trips.filter((_, index) => {
        return this.loadStatus[index].loaded !== true;
      });
    },
    //Boolean to track whether details have successfully loaded for all trips
    allDetailsLoaded() {
      return this.trips.length === this.tripsLoaded.length;
    },
  },
  methods: {
    /*
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    proceed() {
      this.$router.push({ path: "/summary" });
    },
    history() {
      this.$router.push({ path: "/trip-history" });
    },
    bookMore(value) {
      this.$router.push({ path: "/search/" + value });
    },
    delTrip(val) {
      let trips = this.trips.data;
      for (let x = 0; x < trips.length; x++) {
        if (val == trips[x]) {
          // this.trips.data = trips.splice(x, 1);
          this.trips.data = [];
        }
        this.trips.data = [];
      }
      this.tripKey += 1;
    },
    */
    //loads a list of trip
    async getTripList() {
      var post = {
        meta: {
          stateful: false,
          sessionKey: null,
          normalizeResponse: true,
        },
        travelerProfileRecordLocator: this.$globals.profile
          .amadeusRecordLocator,
        //travelerProfileRecordLocator: "HN5NYZ",
        //travelerProfileRecordLocator: "ATUX8T",
        onlyActiveTrips: false,
        onlyInactiveTrips: true,
        officeId: this.$globals.profile.officeId,
      };

      let list = await this.$app.huddleLabsServerCall(
        "amadeus/trips/get-trips",
        post
      );
      return list.data;
    },
    //loads trip details for any trips whose details have not been previously loaded
    async fetchTripDetails() {
      return await Promise.all(
        this.trips.map(async (trip, index) => {
          if (this.loadStatus[index]?.loaded !== true) {
            this.updateLoadStatus(index, { loaded: false, loading: true });

            var post = {
              meta: {
                stateful: false,
                sessionKey: null,
                normalizeResponse: true,
              },
              recordLocator: trip.recordLocator,
              officeId: this.$globals.profile.officeId,
            };

            let result = await this.$app.huddleLabsServerCall(
              "amadeus/trips/show",
              post
            );
            if (result.data) {
              this.$set(this.trips, index, result.data);

              this.updateLoadStatus(index, { loaded: true, loading: false });
            } else {
              this.updateLoadStatus(index, { loaded: false, loading: false });
            }
          }
        })
      );
    },
    /*
    tripMod(value) {
      var details = {
        parent: this,
        component: TripModal,
        props: {
          trip: value,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 400,
        events: {
          delete: (value) => {
            console.log(value);
            this.delTrip(value);
          },
        },
      };

      this.$buefy.modal.open(details);
    },
    */

    initLoadStatus(trips) {
      trips.forEach((_, index) => {
        this.loadStatus[index] = { loaded: false, loading: false };
      });
    },
    updateLoadStatus(index, obj) {
      this.loadStatus[index] = obj;
    },
  },

  async mounted() {
    //get array of trips for the user
    this.trips = await this.getTripList();
    this.pageLoading = false;

    this.initLoadStatus(this.trips);

    if (this.trips.length > 0) {
      this.detailsLoading = true;

      //fetch the full trip details for each trip
      await this.fetchTripDetails();

      /**
       * If some trip details fail to load during first API request for any reason (e.g. 401 errors),
       * this will attempt to load them in the background a second time.
       * If they fail to load a second time, then a notification will be displayed to the user.
       *
       */

      if (!this.allDetailsLoaded) await this.fetchTripDetails();
    } else {
      this.noTripsFound = true;
    }

    this.detailsLoading = false;

    let pendings = this.$store.state.travellersAndTrips.pendingTrips;
    pendings.forEach(function(element) {
      element.pending = true;
    });
    this.trips = pendings.concat(this.trips);
  },
};
</script>

<style scoped>
.trip-count-info {
  text-align: right;
}

.trip-count-info .is-size-6 {
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.trip-count-info .is-size-7 a {
  color: #666;
  text-decoration: none;
}

.trip-count-info .is-size-7 a:hover {
  color: #3273dc;
  text-decoration: underline;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .level {
    display: block !important;
  }

  .level-left,
  .level-right {
    margin-bottom: 1rem;
  }

  .trip-count-info {
    text-align: left;
  }
}
</style>
